export const tableColumnHeaders = {
  groupedTable: [
    { columnLabel: 'Type', columnWidth: '15%' },
    { columnLabel: 'Category', columnWidth: '65%' },
    { columnLabel: 'Proportion', columnWidth: '20%' },
  ],
  groupedTableNoLabels: [
    { columnLabel: '', columnWidth: '15%' },
    { columnLabel: '', columnWidth: '65%' },
    { columnLabel: '', columnWidth: '20%' },
  ],
  eliminationTable: [
    { columnLabel: null, subLabel: null, columnWidth: '18%' },
    {
      columnLabel: 'Proportion eliminated',
      subLabel: '% of weight',
      columnWidth: '10%',
    },
    {
      columnLabel: 'Weight eliminated',
      subLabel: 'metric tonnes',
      columnWidth: '10%',
    },
    {
      columnLabel: 'Quantity eliminated',
      subLabel: 'units',
      columnWidth: '10%',
    },
    {
      columnLabel: 'Primary means of elimination',
      subLabel: null,
      columnWidth: '10%',
    },
    { columnLabel: 'Other details', subLabel: null, columnWidth: '42%' },
  ],
  plannedActionsTable: [
    { columnLabel: null, subLabel: null, columnWidth: '18%' },
    {
      columnLabel: 'Proportion eliminated',
      subLabel: '% of weight',
      columnWidth: '10%',
    },
    {
      columnLabel: 'Weight eliminated',
      subLabel: 'metric tonnes',
      columnWidth: '10%',
    },
    {
      columnLabel: 'Quantity eliminated',
      subLabel: null,
      columnWidth: '10%',
    },
    {
      columnLabel: 'Year Achieved',
      subLabel: null,
      columnWidth: '10%',
    },
    { columnLabel: 'Other details', subLabel: null, columnWidth: '42%' },
  ],
  reuseTable: [
    { columnLabel: null, subLabel: null, columnWidth: '20%' },
    {
      columnLabel: 'Reuse model types',
      subLabel: null,
      columnWidth: '28%',
    },
    {
      columnLabel: 'Markets',
      subLabel: null,
      columnWidth: '22%',
    },
    {
      columnLabel: 'Other details',
      subLabel: null,
      columnWidth: '30%',
    },
  ],
  reusePlanneActionsTable: [
    { columnLabel: null, subLabel: null, columnWidth: '20%' },
    {
      columnLabel: 'Reuse model types',
      subLabel: null,
      columnWidth: '28%',
    },
    {
      columnLabel: 'Markets',
      subLabel: null,
      columnWidth: '22%',
    },
    {
      columnLabel: 'Other details',
      subLabel: null,
      columnWidth: '30%',
    },
  ],
};
